// Alistar — Pulverize: headbutts the front 2 enemies for heavy physical damage and stuns them.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const STUN_DURATION = 1;

export const alistarPulverize: Ability = {
  id: "alistarPulverize",
  displayName: "Pulverize",
  description: "Headbutts the front 2 enemies for heavy physical damage and stuns them for 1 turn.",
  iconId: "Pulverize",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 2)
      .map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 2);
    const stats = effectiveStats(caster);
    const dmg = physicalDamage(stats.ad * 1.5 + 100);
    return targets.map(e => ({
      target: e, amount: dmg, type: "physical" as const,
      effect: { kind: "stun" as const, duration: STUN_DURATION },
    }));
  },
};
